<template>
  <div id="payMethodInfo" v-if="payMethodWayName">
    <!-- 确认订单支付方式信息 -->
    <div class="payMethodInfo-title">
      {{ $t("PayMethodInfo_components.title") }}
    </div>
    <div class="content">
      <div>
        <p class="title">{{ $t("PayMethodInfo_components.title2") }}</p>
        <p
          class="paymentType"
          v-if="payMethodWayName.type && payMethodWayName.type !== ''"
        >
          {{ $t(`buyPayWay.${payMethodWayName.type}`) }}
        </p>
        <p class="paymentWay">
          {{ payMethodWayName.name }}
          <span class="card-number" v-if="payMethodInfo.payWayCode === '10009'"
            >(****{{ cardNumber }})</span
          >
        </p>
      </div>
      <div class="content-right">
        <p
          class="payMethod-icon"
          v-if="payMethodWayName.icon && payMethodWayName.icon !== ''"
        >
          <img
            :src="
              require('@/assets/images/paymentIcon/' + payMethodWayName.icon)
            "
            alt=""
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 确认支付页 - 支付方式信息
 */
import { mapState } from "vuex";
import paymentMethods from "@/assets/json/paymentMethods.json";
import valid from "card-validator";

export default {
  name: "index",
  computed: {
    ...mapState("buyNftOrder", {
      //支付方式信息
      process_payMethodInfo: (state) => state.payMethodInfo,
    }),
    payMethodInfo() {
      return this.process_payMethodInfo;
    },
    //脱敏信用卡号
    cardNumber() {
      if (
        this.payMethodInfo.cardNumber &&
        this.payMethodInfo.cardNumber !== ""
      ) {
        let card = this.payMethodInfo.cardNumber;
        return card && card !== "" ? card.substring(card.length - 4) : "";
      }
      return "";
    },
    payMethodWayName() {
      //引入支付方式列表
      let paymentMethodsList = JSON.parse(JSON.stringify(paymentMethods));
      let paymentMethodsInfo = paymentMethodsList.filter((item) => {
        //针对印尼选择银行 bank Transfer
        if (
          this.payMethodInfo.payWayCode === "10003" &&
          item.payWayCode === "10003"
        ) {
          return item.bankCode === this.payMethodInfo.bankCode;
        }
        //针对卡支付做出调整
        if (
          this.payMethodInfo.payWayCode === "10009" &&
          item.payWayCode === "10009"
        ) {
          let validObject = valid.number(this.payMethodInfo.cardNumber);
          if (
            validObject.isValid &&
            ["mastercard"].includes(validObject.card.type)
          ) {
            return item.cardType === validObject.card.type ? item.name : "";
          }
        }
        return item.payWayCode === this.payMethodInfo.payWayCode;
      })[0];
      return paymentMethodsInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
#payMethodInfo {
  .payMethodInfo-title {
    font-family: Medium;
    font-weight: 500;
    font-size: 0.16rem;
    line-height: 0.19rem;
    color: #000000;
    margin-bottom: 0.16rem;
  }
  .content {
    width: 100%;
    min-height: 0.64rem;
    background: #ffffff;
    border: 1px solid #ebebeb;
    border-radius: 0.16rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.12rem 0.16rem 0.1rem 0.16rem;
    .title {
      font-family: Regular;
      font-weight: 400;
      font-size: 0.12rem;
      line-height: 0.16rem;
      color: #6e7687;
    }
    .paymentType {
      font-family: Regular;
      font-size: 0.12rem;
      font-weight: 500;
      line-height: 0.16rem;
      color: #0059da;
    }
    .paymentWay {
      font-family: Medium;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: 0.2rem;
      color: #031633;
      margin-top: 0.1rem;
      .card-number {
        font-family: Regular;
        font-weight: 400;
        font-size: 0.13rem;
        line-height: 0.16rem;
        color: #6e7687;
        margin-left: 0.08rem;
      }
    }
    .content-right {
      margin-left: auto;
      .payMethod-icon {
        display: flex;
        align-items: center;
        width: 0.42rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
